export enum RowLinkType {
  PRO_DRILL_DOWN = 'PRO_DRILL_DOWN',
  MATS = 'MATS',
  PICK_A_PAGE = 'PICK_A_PAGE',
  EXAM_JUMPSTART = 'EXAM_JUMPSTART'
}

export default interface RowLinkConfiguration {
  rowLinkType: RowLinkType;
  tag?: string;
}
